export const contentTableConfig = {
  propList: [
    { prop: 'customerName', label: '客户姓名', minWidth: '60' },
    { prop: 'custNickName', label: '客户昵称', minWidth: '60' },
    { prop: 'exploitAccount', label: '开发账号', minWidth: '60' },
    {
      prop: 'fundsDesc',
      label: '资金量（万）',
      minWidth: '70',
      sortable: 'custom'
    },
    {
      prop: 'proofImgUrls',
      label: '资金证明图',
      minWidth: '60',
      slotName: 'proofImgUrls'
    },
    { prop: 'remark', label: '备注', minWidth: '80' },
    { prop: 'undertakeDate', label: '资源承接日期', minWidth: '80' },
    { prop: 'empName', label: '员工', minWidth: '50' },
    { prop: 'verifyResultDesc', label: '业绩核实结果', minWidth: '60' },
    { label: '操作', minWidth: '130', slotName: 'sHandler' }
  ],
  showSelectColumn: true
}
